import React from 'react';

const Spinner = ({ size = "default", className = "" }) => {
  const sizeClasses = {
    sm: "w-4 h-4 border-2",
    default: "w-8 h-8 border-4",
    lg: "w-12 h-12 border-4"
  };

  const sizeClass = sizeClasses[size] || sizeClasses.default;

  return (
    <div className={`${className}`}>
      <div 
        className={`${sizeClass} rounded-full border-t-blue-600 border-r-transparent border-b-blue-600 border-l-transparent animate-spin`} 
        role="status" 
        aria-label="Carregando"
      />
    </div>
  );
};

export default Spinner;
